export default __webpack_public_path__ + "static/media/contributor-blog-card.c5ae54d0.png";